if (!customElements.get('read-more-content')) {
  customElements.define(
    'read-more-content',
    class ReadMoreContent extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-read-more-body]');
        this.toggle = this.querySelector('[data-read-more-toggle]');
        this.moreLabel = this.querySelector('[data-read-more-more]');
        this.lessLabel = this.querySelector('[data-read-more-less]');
        if (!this.body || !this.toggle) return;

        this.expanded = false;
        this.toggle.addEventListener('click', this.onToggle.bind(this));

        // Re-measure when the surrounding accordion opens (content has no height while closed).
        this.details = this.closest('details');
        if (this.details) {
          this.details.addEventListener('toggle', () => {
            if (this.details.open) this.refresh();
          });
        }

        // Clamp height is width-dependent, so re-check on resize (debounced).
        this._resizeTimer = null;
        window.addEventListener('resize', () => {
          clearTimeout(this._resizeTimer);
          this._resizeTimer = setTimeout(this.refresh.bind(this), 150);
        });

        this.refresh();
      }

      // Decide whether the toggle is needed based on whether the content overflows the clamp.
      refresh() {
        if (this.expanded) return; // never re-clamp once the user expanded
        this.classList.add('is-clamped');
        const fits = this.body.scrollHeight <= this.body.clientHeight + 2;
        if (fits) {
          this.classList.remove('is-clamped');
          this.toggle.hidden = true;
        } else {
          this.toggle.hidden = false;
        }
      }

      onToggle() {
        this.expanded = !this.expanded;
        this.classList.toggle('is-expanded', this.expanded);
        this.classList.toggle('is-clamped', !this.expanded);
        this.toggle.setAttribute('aria-expanded', String(this.expanded));
        if (this.moreLabel) this.moreLabel.hidden = this.expanded;
        if (this.lessLabel) this.lessLabel.hidden = !this.expanded;
      }
    }
  );
}
